export const CHANNELS_LABEL = 'Channels :';
export const CATEGORIES_LABEL = 'Catégories :';
